<template>
    <div>
        <div class="page_title">
            <i class="el-icon-arrow-left" style="cursor: pointer;" @click="$router.back()"></i>
            {{$i18n.t('releaseMsg.text1')}}
        </div>

        <div class="table_card">
            <el-descriptions :column="3" :title="`${$i18n.t('releaseMsg.text2')}${msg.firmwareModel}`">
                <el-descriptions-item :label="$i18n.t('releaseMsg.text3')">{{msg.version}}</el-descriptions-item>
                <el-descriptions-item :label="$i18n.t('releaseMsg.text4')">{{msg.pid}}</el-descriptions-item>
                <el-descriptions-item :label="$i18n.t('releaseMsg.text5')">{{msg.createTime}}</el-descriptions-item>
                <el-descriptions-item :label="$i18n.t('releaseMsg.text6')">{{$config.getMsgItemUtil($message.firmwareTypeList, msg.firmwareType, 'value', 'text')}}</el-descriptions-item>

                <el-descriptions-item :label="$i18n.t('releaseMsg.text71')">
                  {{msg.versionType === 1 ? $i18n.t('releaseMsg.text70') : $i18n.t('releaseMsg.text69')}}
                </el-descriptions-item>
                <el-descriptions-item :label="$i18n.t('releaseMsg.text73')">
                  {{msg.code}}
                </el-descriptions-item>
                <el-descriptions-item v-for="(item, index) in urls" :key="index" :label="$i18n.t('releaseMsg.text7')" :labelStyle="{marginTop: index > 0 ? '-20px' : '-10px'}" :contentStyle="{marginTop: index > 0 ? '-20px' : '-10px'}" :span="5">
                    <span v-if="!item.isEdit">
                        <span :id="`url${index}`">{{item.url}}</span>
                        <el-popover
                          placement="bottom"
                          title="md5"
                          width="200"
                          trigger="click"
                          :content="item.md5">
                          <el-button slot="reference" type="text" style="margin-left: 10px;">md5</el-button>
                        </el-popover>
                        <el-button type="text" style="margin-left: 10px;" :class="`copy${index}`" :data-clipboard-target="`#url${index}`">{{$i18n.t('releaseMsg.text8')}}</el-button>
                        <el-button type="text" @click="item.isEdit = !item.isEdit;">{{$i18n.t('releaseMsg.text9')}}</el-button>
                    </span>
                    <span v-else>
                        <el-input size="mini" class="url_input" :placeholder="$i18n.t('releaseMsg.text12')" v-model="item.url"/>
                        <el-button type="text" style="margin-left: 10px;" v-if="!item.editLoading" @click="cancel(item, index)">{{$i18n.t('releaseMsg.text10')}}</el-button>
                        <el-button type="text" :loading="item.editLoading" @click="modifyUrl(item, index)">{{$i18n.t('releaseMsg.text11')}}</el-button>
                    </span>
                </el-descriptions-item>
            </el-descriptions>
            <div class="set_update">
                <el-descriptions class="left_form" :column="2" :title="$i18n.t('releaseMsg.text13')">
                    <el-descriptions-item :label="$i18n.t('releaseMsg.text14')">{{$config.getMsgItemUtil($message.installTypeList, msg.installType, 'value', 'label')}}</el-descriptions-item>
                    <el-descriptions-item :label="$i18n.t('releaseMsg.text15')">{{$config.getMsgItemUtil($message.triggerModeList, msg.triggerType, 'value', 'label')}}</el-descriptions-item>
                    <el-descriptions-item :label="$i18n.t('releaseMsg.text16')">{{msg.reboot ? $i18n.t('ota.text82') : $i18n.t('ota.text83')}}</el-descriptions-item>
                    <el-descriptions-item :labelStyle="{opacity: 0}"></el-descriptions-item>
                    <el-descriptions-item :label="$i18n.t('releaseMsg.text17')" :span="3" v-if="msg.versionDescribe">
                        <span class="notes1" :style="{whiteSpace: isShowDescribe ? 'pre-line' : 'nowrap'}" :title="msg.versionDescribe">
                            {{`${msg.versionDescribe}`}}
                            <i class="el-icon-caret-top" style="cursor: pointer;color: #409EFF;" v-if="isShowDescribe && msg.versionDescribe.length > 14" @click="isShowDescribe = !isShowDescribe"></i>
                        </span>
                        <i class="el-icon-caret-bottom" style="cursor: pointer;color: #409EFF;" v-if="!isShowDescribe && msg.versionDescribe.length > 14" @click="isShowDescribe = !isShowDescribe"></i>
                    </el-descriptions-item>
                </el-descriptions>
                <div class="right_statistics">
                    <div class="statistics_card">
                        <div class="statistics_card_top">{{otaStatisticInfo.totalDeviceCount}}</div>
                        <div class="statistics_card_bottom">{{$i18n.t('releaseMsg.text18')}}</div>
                    </div>
                    <div class="statistics_card">
                        <div class="statistics_card_top">{{otaStatisticInfo.successCount}}</div>
                        <div class="statistics_card_bottom">{{$i18n.t('releaseMsg.text19')}}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="from_card">
            <el-radio-group v-model="releaseType" v-if="(!isRelease || isEdit) && !isBeyondTheReleaseTime">
                <el-radio-button :label="item.id" v-for="(item, index) in releaseTypeList" :key="index">{{item.value}}</el-radio-button>
            </el-radio-group>
            <el-radio-group v-model="backup.planPublishType ? backup.planPublishType : backup.publishStatus" v-else>
                <el-radio-button :label="backup.planPublishType ? backup.planPublishType : backup.publishStatus">{{$config.getMsgItemUtil(releaseTypeList, backup.planPublishType ? backup.planPublishType : backup.publishStatus, 'id', 'value')}}</el-radio-button>
            </el-radio-group>

            <div class="title" v-show="releaseType === 1">
                <div class="title_div"></div>
                <span class="title_text">{{$i18n.t('releaseMsg.text39')}}</span>
            </div>

            <el-radio-group class="second_publish"
                            :disabled="!isEdit && isRelease" v-show="releaseType === 1" v-model="secondPublishType">
              <el-radio :label="1">{{$i18n.t('releaseMsg.text58')}}</el-radio>
              <el-radio :label="2" v-if="msg.triggerType === 1">{{$i18n.t('releaseMsg.text59')}}</el-radio>
              <el-radio :label="3" v-if="msg.triggerType === 1">{{$i18n.t('releaseMsg.text60')}}</el-radio>
            </el-radio-group>
            <el-input
                :disabled="!isEdit && isRelease"
                v-show="releaseType === 1 && secondPublishType === 1"
                style="margin-top: 10px"
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 5}"
                :placeholder="
                `${$i18n.t('releaseMsg.text40')}
${$i18n.t('releaseMsg.text41')}
${$i18n.t('releaseMsg.text42')}
${$i18n.t('releaseMsg.text43')}
`"
                v-model="uniqueId">
            </el-input>
            <el-upload
                v-show="releaseType === 1 && secondPublishType === 1"
                class="upload-demo"
                :disabled="!isEdit && isRelease"
                :style="{cursor: isEdit ? 'pointer' : 'not-allowed', opacity: isEdit ? '1' : '.8'}"
                :action="$message.deviceUpgradeUrl"
                :headers="{
                    accessToken: $token.getToken().accessToken,
                    refreshToken: $token.getToken().refreshToken,
                    language: language
                }"
                :before-upload="onbeforeunload"
                :on-remove="handleRemove"
                :on-success="onSuccess"
                :on-error="onError"
                :limit="1"
                :file-list="fileList">
                <el-button :disabled="!isEdit && isRelease" size="mini" icon="el-icon-plus" :loading="fileLoading">{{$i18n.t('releaseMsg.text44')}}</el-button>
                <div slot="tip" class="el-upload__tip">{{$i18n.t('releaseMsg.text45')}} <a style="color: rgb(24, 144, 255)" href="https://oss.funlink.cloud/common/hbxpfca/res/20240928/dz7qz8yksq9s/ota_unique_key.xlsx">{{$i18n.t('releaseMsg.text46')}}</a> {{$i18n.t('releaseMsg.text47')}}</div>
            </el-upload>

            <div class="update_device_number" v-show="releaseType === 1 && secondPublishType === 2">
              <span>{{$i18n.t('releaseMsg.text61')}}</span>
              <div class="update_device_number_input">
                <el-input-number
                  :disabled="!isEdit && isRelease"
                  v-model="publishAmount"
                  :min="0"
                  :max="onlineNumber"
                />
                <span style="margin-left: 10px;">
                  {{$i18n.t('releaseMsg.text62')}}：<span style="color: #1890FF;margin-right: 4px;">{{onlineNumber}}</span>{{$i18n.t('releaseMsg.text63')}}

                  <el-popover
                    placement="top-start"
                    title=""
                    width="200"
                    trigger="hover"
                    :content="$i18n.t('releaseMsg.text64')">
                      <i
                        :class="objectIcon"
                        @mouseover="objectIcon = 'empower_question_coicon icon-yuanyin'"
                        @mouseleave="objectIcon = 'empower_question_alicon iconfont_al icon-yiwen'"
                        slot="reference"></i>
                  </el-popover>
                </span>
              </div>
            </div>

            <div class="continent_list" :style="{opacity: !isEdit && isRelease ? '0.5' : '1'}" v-show="releaseType === 1 && secondPublishType === 3">
              <div
                :class="continentsCode === item.continentsCode ? 'continent_item_action' : 'continent_item'"
                v-for="(item, index) in continentList"
                :key="index"
                :style="{cursor: !isEdit && isRelease ? 'not-allowed' : 'pointer'}"
                @click="selectContinent(item)"
              >
                <div class="continent_item_heard">
                  <span class="continent_item_title">{{item.continentsName}}</span>
                  <span class="continent_item_device_number">{{$i18n.t('releaseMsg.text65')}}：<span style="color: rgba(0, 0, 0, 0.65);">{{item.totalAmount}}</span></span>
                </div>
                <span class="continent_item_time">{{ $i18n.t('releaseMsg.text66') }}：{{item.modifyTime}}</span>
              </div>
            </div>
            <div class="title" v-show="releaseType === 2">
                <div class="title_div"></div>
                <span class="title_text">{{$i18n.t('releaseMsg.text48')}}</span>
            </div>
            <el-input-number
                v-show="releaseType === 2"
                :disabled="!isEdit && isRelease"
                v-model="grayAmount"
                :min="0"
                style="margin-top: 10px;"
                :max="otaStatisticInfo.totalDeviceCount - otaStatisticInfo.successCount"/>
            <div class="title">
                <div class="title_div"></div>
                <span class="title_text">{{$i18n.t('releaseMsg.text49')}}</span>
            </div>
            <el-radio-group :disabled="(!isEdit && isRelease) || isBeyondTheReleaseTime" v-model="releaseTimeType">
                <el-radio :label="1">{{$i18n.t('releaseMsg.text50')}}</el-radio>
                <el-radio :label="2">
                    {{$i18n.t('releaseMsg.text51')}}
                    <el-date-picker
                        style="margin-left: 10px;"
                        :disabled="releaseTimeType === 1 || (!isEdit && isRelease) || isBeyondTheReleaseTime"
                        v-model="releaseTime"
                        :picker-options="pickerOptions"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :placeholder="$i18n.t('releaseMsg.text52')">
                    </el-date-picker>
                </el-radio>
            </el-radio-group>
            <br>
            <el-button style="margin-top: 20px" :loading="loading" @click="release" type="primary" v-if="!isRelease">{{$i18n.t('releaseMsg.text53')}}</el-button>
            <div v-else>
                <el-button style="margin-top: 20px" :loading="removedLoading" @click="banFirmware" v-if="!isEdit">{{$i18n.t('releaseMsg.text54')}}</el-button>
                <el-button style="margin-top: 20px;margin-left: 10px;" @click="releaseEdit" v-if="!isEdit || (!isEdit && releaseType === 3 && releaseTimeType === 1)">{{$i18n.t('member.text10')}}</el-button>

                <el-button style="margin-top: 20px" @click="cancelEdit" v-if="isEdit">{{$i18n.t('releaseMsg.text26')}}</el-button>
                <el-button style="margin-top: 20px;margin-left: 10px;" type="primary" :loading="loading"  @click="release" v-if="isEdit">{{$i18n.t('releaseMsg.text53')}}</el-button>

                <el-button style="margin-top: 20px;margin-left: 10px;" @click="allRelease" v-if="!isEdit && releaseType === 2">{{$i18n.t('releaseMsg.text57')}}</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions} from "vuex";
import Clipboard from "clipboard";

export default {
    name: "releaseMsg",
    data() {
        return {
            releaseType: 1,
            grayAmount: 0,
            releaseTypeList: [
                {id: 1, value: this.$i18n.t('releaseMsg.text20')},
                {id: 2, value: this.$i18n.t('releaseMsg.text21')},
                {id: 3, value: this.$i18n.t('releaseMsg.text22')}
            ],
            objectIcon: "empower_question_alicon iconfont_al icon-yiwen",
            backup: {},
            language: localStorage.getItem('language'),
            uniqueId: '',
            publishAmount: 0,
            onlineNumber: 0,
            continentsCode: '',
            secondPublishType: 1,
            releaseTimeType: 1,
            releaseTime: '',
            fileLoading: false,
            loading: false,
            removedLoading: false,
            msg: {},
            urls: [],
            otaStatisticInfo: {
                "totalDeviceCount": "0",
                "successCount": "0",
                "failedCount": "0",
                "upgradingCount": "0",
                "noUpgradingCount": "0"
            },
            fileList: [],
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() <= Date.now();
                }
            },
            isRelease: false,
            isEdit: false,
            isBeyondTheReleaseTime: false,
            isShowDescribe: false,
            clipboardList: [],
            continentList: []
        }
    },
    mounted() {
        this.init();
    },
    methods: {

        ...mapActions('maintain', ['getOtaFileDetail', 'otaStatistic', 'queryOTALogPager', 'modifyDownloadUrl', 'publishOTA', 'banOTA', 'getServerTime', 'countByOnlineTime', 'queryStatisticByContinents']),

        init() {
            this.getOtaFileDetail({
                otaFileCode: this.$route.query.code,
                type: 1
            })
              .then(res => {
                if (res.result.planPublishType) {
                    this.isRelease = true;
                } else {
                    this.isRelease = res.result.publishStatus !== 0
                }
                this.msg = res.result;
                this.releaseType = this.isRelease ? (res.result.publishStatus > 0 ? res.result.publishStatus : res.result.planPublishType) : res.result.publishStatus;
                this.uniqueId = this.isRelease ? (res.result.planUniqueKeys ? res.result.planUniqueKeys : res.result.macs) : res.result.macs;
                this.grayAmount = res.result.grayAmount ? res.result.grayAmount : 0;
                this.releaseTimeType = res.result.publishTimeType ? res.result.publishTimeType : 1;
                this.releaseTime = this.releaseTimeType === 1 ? '' : res.result.planPublishTime;
                this.secondPublishType = res.result.secondPublishType ? res.result.secondPublishType : 1;
                this.continentsCode = res.result.continentsCode ? res.result.continentsCode : '';
                this.publishAmount = res.result.publishAmount ? res.result.publishAmount : 0;
                this.getOnlineNumber();
                this.getStatisticByContinents();
                this.backup = res.result;
                if (this.releaseType === 0) this.releaseType = 1;
                if (this.isRelease) {
                    this.isBeyondTheReleaseTime = this.releaseTime > 0 ? (Date.now() <= new Date().getTime(this.releaseTime)) : this.releaseTimeType === 1;
                } else {
                    this.isBeyondTheReleaseTime = false;
                }
                if (res.result.hasChannel) {
                    let urls = [];
                    res.result.channelList.forEach((item, index) => {
                        urls.push({
                            url: item.downUrl ? item.downUrl : item.fileUrl,
                            url1: item.downUrl ? item.downUrl : item.fileUrl,
                            isEdit: false,
                            editLoading: false,
                            code: item.code,
                            md5: item.md5Sign
                        })
                        let clipboard = new Clipboard('.copy'+index).on('success', (e) => {
                            this.$dialog.showMessage(this.$i18n.t('product.text13'), this.$config.TOAST_SUCCESS);
                        });
                        this.clipboardList.push(clipboard)
                    })
                    this.urls = urls;
                } else {
                    this.urls = [{
                        url: res.result.downUrl ? res.result.downUrl : res.result.srcFileUrl,
                        url1: res.result.downUrl ? res.result.downUrl : res.result.srcFileUrl,
                        isEdit: false,
                        editLoading: false,
                        md5: res.result.md5Sign
                    }]
                    let clipboard = new Clipboard('.copy0').on('success', (e) => {
                        this.$dialog.showMessage(this.$i18n.t('product.text13'), this.$config.TOAST_SUCCESS);
                    });
                    this.clipboardList.push(clipboard)
                }
                console.log(this.isRelease, this.isBeyondTheReleaseTime)
            }, err => {
                this.$dialog.showMessage(err.resultMsg, this.$config.TOAST_ERROR);
            })

            this.otaStatistic({
                otaFileCode: this.$route.query.code
            }).then(res => {
                this.otaStatisticInfo = res.result;
            }, err => {
                this.$dialog.showMessage(err.resultMsg, this.$config.TOAST_ERROR);
            })
        },

        selectContinent(item) {
          if (!this.isEdit && this.isRelease) return
          this.continentsCode = item.continentsCode;
        },

        getOnlineNumber() {
          this.countByOnlineTime({
            pid: this.msg.pid,
            firmwareModel: this.msg.firmwareModel
          }).then(res => {
            this.onlineNumber = res.result;
          }, err => {
            this.$dialog.showMessage(err.resultMsg, this.$config.TOAST_ERROR);
          })
        },

        getStatisticByContinents() {
          this.queryStatisticByContinents({
            pid: this.msg.pid,
            firmwareModel: this.msg.firmwareModel
          }).then(res => {
            this.continentList = res.result;
          }, err => {
            this.$dialog.showMessage(err.resultMsg, this.$config.TOAST_ERROR);
          })
        },

        banFirmware() {
            this.$dialog.showConfirm({
                content: this.$i18n.t('releaseMsg.text23'),
                title: this.$i18n.t('releaseMsg.text24'),
                btn1: this.$i18n.t('releaseMsg.text25'),
                btn2: this.$i18n.t('releaseMsg.text26'),
                icon: 2
            }, () => {
                this.banOTA({otaFileCode: this.$route.query.code}).then(res => {
                    this.$dialog.showMessage(this.$i18n.t('releaseMsg.text27'), this.$config.TOAST_SUCCESS);
                    this.init();
                }, err => {
                    console.log(err);
                    this.$dialog.showMessage(err.resultMsg, this.$config.TOAST_ERROR);
                })
            }, () => {

            })
        },

        splicMd5() {
            let md5 = '';
            this.urls.forEach((item, index) => {
                md5 = md5 + (index > 0 ? ',' : '') + item.md5
            })
            return md5;
        },

        async release() {
            if (this.releaseType === 0) {
                this.$dialog.showMessage(this.$i18n.t('releaseMsg.text28'), this.$config.TOAST_WARNING);
                return
            }
            if (this.releaseType === 2 && this.grayAmount === 0 && !this.grayAmount) {
                this.$dialog.showMessage(this.$i18n.t('releaseMsg.text29'), this.$config.TOAST_WARNING);
                return;
            }
            if (this.releaseType === 1) {
              if (!this.uniqueId && this.secondPublishType === 1) {
                this.$dialog.showMessage(this.$i18n.t('releaseMsg.text30'), this.$config.TOAST_WARNING);
                return;
              }
              if (this.publishAmount === 0 && this.secondPublishType === 2) {
                this.$dialog.showMessage(this.$i18n.t('releaseMsg.text67'), this.$config.TOAST_WARNING);
                return;
              }
              if (this.continentsCode === '' && this.secondPublishType === 3) {
                this.$dialog.showMessage(this.$i18n.t('releaseMsg.text68'), this.$config.TOAST_WARNING);
                return;
              }
            }
            if (this.releaseTimeType === 2 && this.releaseTime === "") {
                this.$dialog.showMessage(this.$i18n.t('releaseMsg.text31'), this.$config.TOAST_WARNING);
                return;
            }
            let msg = await this.getServerTime();
            if (this.releaseTimeType === 2 && (new Date(this.releaseTime).getTime() - Number(msg.result)) < (10*60*1000)) {
                this.$dialog.showMessage(this.$i18n.t('releaseMsg.text32'), this.$config.TOAST_WARNING);
                return;
            }
            this.loading = true;
            let data = {
                otaFileCode: this.$route.query.code,
                publishTimeType: this.releaseTimeType,
                publishType: this.releaseType
            }
            if (this.releaseTimeType === 2) data.planPublishTime = this.releaseTime;
            if (this.releaseType === 1) {
              data.secondPublishType = this.secondPublishType;
              this.secondPublishType === 1 && (data.uniqueKeys = this.uniqueId);
              this.secondPublishType === 2 && (data.publishAmount = this.publishAmount);
              this.secondPublishType === 3 && (data.continentsCode = this.continentsCode);
            }
            if (this.releaseType === 2) data.grayAmount = this.grayAmount;
            this.publishOTA(data).then(() => {
                this.$dialog.showMessage(this.$i18n.t('releaseMsg.text33'), this.$config.TOAST_SUCCESS);
                if (this.releaseType === 3 && this.releaseTimeType === 1) {
                    this.$router.back();
                    return;
                }
                this.init();
                this.cancelEdit();
            }, err => {
                this.$dialog.showMessage(err.resultMsg, this.$config.TOAST_ERROR);
            }).finally(() => this.loading = false)
        },

        modifyUrl(item, index) {
            this.urls[index].editLoading = true;
            let data = {
                fileUrl: this.urls[index].url,
                otaFileCode: this.$route.query.code
            }
            if (item.code) data.channelCode = item.code
            this.modifyDownloadUrl(data).then(res => {
                this.$dialog.showMessage(this.$i18n.t('releaseMsg.text34'), this.$config.TOAST_SUCCESS);
                this.urls[index].isEdit = false;
                this.urls[index].url1 = this.urls[index].url;
            }, err => {
                this.$dialog.showMessage(err.resultMsg, this.$config.TOAST_ERROR);
            }).finally(() => this.urls[index].editLoading = false)
        },

        cancelEdit() {
            this.releaseTime = this.backup.planPublishTime;
            this.releaseType = this.isRelease ? (this.backup.publishStatus > 0 ? this.backup.publishStatus : this.backup.planPublishType) : this.backup.publishStatus;
            this.uniqueId = this.isRelease ? (this.backup.planUniqueKeys ? this.backup.planUniqueKeys : this.backup.macs) : this.backup.macs;
            this.grayAmount = this.backup.grayAmount ? this.backup.grayAmount : 0;
            this.releaseTimeType = this.backup.publishTimeType ? this.backup.publishTimeType : 1;
            this.releaseTime = this.releaseTimeType === 1 ? '' : this.backup.planPublishTime;

            if (this.releaseTypeList.length === 1) {
                this.isBeyondTheReleaseTime = true;
                this.releaseTypeList = [
                    {id: 1, value: this.$i18n.t('releaseMsg.text20')},
                    {id: 2, value: this.$i18n.t('releaseMsg.text21')},
                    {id: 3, value: this.$i18n.t('releaseMsg.text22')}
                ];
            }

            this.isEdit = !this.isEdit;
        },

        releaseEdit() {
            this.isEdit = !this.isEdit;
            if (this.releaseType === 3) {
                this.isBeyondTheReleaseTime = false;
                this.releaseTypeList = [{id: 3, value: this.$i18n.t('releaseMsg.text22')}]
            }
        },

        allRelease() {
            this.releaseType = 3;
            this.isEdit = true;
            this.isBeyondTheReleaseTime = false;
            this.releaseTypeList = [{id: 3, value: this.$i18n.t('releaseMsg.text22')}]
        },

        cancel(item, index) {
            setTimeout(() => {
                this.urls[index].isEdit = !item.isEdit;
                this.urls[index].url = this.urls[index].url1
            }, 100)
        },

        handleRemove(file, fileList) {
            this.fileList = []
        },

        onbeforeunload(file) {
            this.fileLoading = true;
        },

        onSuccess(res, file, fileList) {
            this.fileLoading = false;
            console.log(res)
            if (res.success) {
                this.uniqueId = (this.uniqueId ? this.uniqueId : '') + ((this.uniqueId && this.uniqueId !== '') ? ',' : '') + res.result;
            } else {
                this.$dialog.showMessage(res.resultMsg, this.$config.TOAST_ERROR);
                this.fileList = []
            }
        },

        onError(err, file, fileList) {
            this.fileLoading = false;
            this.$dialog.showMessage(err.resultMsg, this.$config.TOAST_ERROR);
            console.log('onError', err, file, fileList)
        }
    },

    destroyed() {
        if (this.clipboardList.length > 0) {
            this.clipboardList.forEach(item => item.destroy())
            this.clipboardList = [];
        }
    }
}
</script>

<style scoped>

.table_card {
    background: #FFFFFF;
    border-radius: 8px;
    position: relative;
    margin: 64px 24px 20px 24px;
    box-shadow: 0 0 4px 0 #BCBCBC;
    padding: 20px;
    text-align: left;
    animation: fadeInDown; /* referring directly to the animation's @keyframe declaration */
    animation-duration: 1s; /* don't forget to set a duration! */
}

.title {
    font-size: 18px;
    color: rgb(51, 51, 51);
    font-weight: bold;
}

/deep/ .el-descriptions-item__container {
    align-items: center;
    /*margin-top: -10px;*/
}

/deep/ .left_form .el-descriptions__table:last-child tbody:last-child .el-descriptions-item__container:last-child {
    align-items: flex-start;
}

.set_update {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.left_form {
    flex: 1;
}

.right_statistics {
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    height: 100%;
}

.notes {
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.notes1 {
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    /*white-space: nowrap;*/
}

/deep/ .el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
    padding-bottom: 6px;
}

/deep/ .el-descriptions__header {
    margin-bottom: 10px;
}

.statistics_card {
    min-width: 250px;
    height: 100%;
    border: 1px solid #c1c1c1;
    border-radius: 8px;
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
}

.statistics_card_top {
    color: rgb(0, 0, 0);
    font-size: 36px;
}

.statistics_card_bottom {
    margin-top: 10px;
    color: rgb(0, 0, 0);
    font-size: 14px;
}

.from_card {
    background: #FFFFFF;
    border-radius: 8px;
    position: relative;
    margin: 0 24px 20px 24px;
    box-shadow: 0 0 4px 0 #BCBCBC;
    padding: 20px;
    text-align: left;
    animation: fadeInUp; /* referring directly to the animation's @keyframe declaration */
    animation-duration: 1s; /* don't forget to set a duration! */
}

.title {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 30px;
}

.title_div {
    width: 5px;
    height: 18px;
    background-color: rgb(129, 194, 255);
}

.title_text {
    font-size: 16px;
    color: rgb(51, 51, 51);
    font-weight: bold;
    margin-left: 11px;
}

.upload-demo {
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
}

/deep/ .el-upload__tip {
    margin: 0 10px!important;
}

/deep/ .el-upload-list__item:first-child {
    margin-top: 0!important;
}

/deep/ .el-icon-close-tip {
    display: none!important;
}

.url_input {
    width: 600px;
}

.second_publish {
  margin: 20px 0;
}

.update_device_number {
  display: flex;
  flex-direction: column;
}

.update_device_number_input {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 10px;
}

.continent_list {
  width: 100%;
  display: flex;
  flex-direction: row;
  overflow-x: auto; /* 关键属性 - 启用横向滚动 */
  white-space: nowrap; /* 防止子元素换行 */
}

.continent_item {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  background: rgb(247, 247, 247);
  border-radius: 4px;
  padding: 16px;
  margin-right: 12px;
  margin-bottom: 12px;
  cursor: pointer;
}

.continent_item_action {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  background: rgba(24, 144, 255, 0.05);
  border: 1px solid rgb(24, 144, 255);
  border-radius: 4px;
  padding: 16px;
  margin-right: 12px;
  margin-bottom: 12px;
  cursor: pointer;
}

.continent_item_heard {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.continent_item_title {
  font-size: 16px;
  font-weight: bold;
}

.continent_item_device_number {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.4);
}

.continent_item_time {
  margin-top: 8px;
  font-size: 10px;
  color: rgba(0, 0, 0, 0.4);
}

.empower_question_coicon {
  color: #3296FA;
  font-size: 16px;
  cursor: pointer;
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.empower_question_alicon {
  color: #3296FA;
  font-size: 16px;
  cursor: pointer;
}
</style>
